import { useMutation, useQuery } from 'react-query';
import {
  getCompanieReportConfig,
  getCompanieReportConfigPublic,
  putCompaniesReportConfig,
} from './CompaniesReportConfig.service';
import { CompanyReportRequest } from '@/core/domain/reports/company/Company.types';
import { notification } from 'antd';
import notificationError from '@/utils/functions/notificationError';

export function useCompanyReportConfig(id?: string) {
  const query = useQuery(
    ['companyReport'],
    () => (!!id ? getCompanieReportConfig(id) : undefined),
    {
      onError(error) {
        notificationError(error, {
          type: 'info',
          translate: (errors) =>
            errors.map((err) =>
              err.includes('not exists or already has a Report Settings')
                ? 'Esta empresa ainda não possui configurações de relatório'
                : err,
            ),
          message: 'Configuração não encontrada',
        });
      },
      enabled: !!id,
    },
  );
  return query;
}

export function useCompanyReportConfigPublic(id?: number) {
  return useQuery(
    ['companyReportPublic'],
    () => getCompanieReportConfigPublic(id),
    {
      enabled: !!id,
      onError(error) {
        notificationError(error);
      },
    },
  );
}

export function useCompanyReportConfigUpdate() {
  const query = useMutation(
    (obj: CompanyReportRequest) => putCompaniesReportConfig(obj),
    {
      onSuccess() {
        notification.success({
          message: 'Configurações atualizadas com sucesso!',
          description:
            'As configurações de relatórios foram atualizadas para esta empresa.',
        });
      },
      onError(error) {
        notificationError(error);
      },
    },
  );
  return query;
}
